module.exports = __webpack_public_path__ + "img/course_living_float_btn.6f6b15c4.png";